var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#D7E7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9459 8.62171L11.5926 16.6834L9.37592 14.315C8.96759 13.93 8.32592 13.9067 7.85925 14.2334C7.40425 14.5717 7.27592 15.1667 7.55592 15.645L10.1809 19.915C10.4376 20.3117 10.8809 20.5567 11.3826 20.5567C11.8609 20.5567 12.3159 20.3117 12.5726 19.915C12.9926 19.3667 21.0076 9.8117 21.0076 9.8117C22.0576 8.73837 20.7859 7.79337 19.9459 8.61004V8.62171Z",
    fill: "#2B81FC"
  })));
};
export default SvgCheckIcon;